import moment from 'moment';

const isActive = record => record && !record.deleted_reason;

const timestamp = value => {
  const date = moment(value, moment.ISO_8601, true);
  return value && date.isValid() ? date.valueOf() : 0;
};

const updatedDate = item =>
  timestamp(item.modified) ? item.modified : item.created;

export const formatPlaidDate = value =>
  timestamp(value)
    ? moment(value).format('MMM D, YYYY h:mm A')
    : 'Not available';

export const maskPlaidAccount = value => {
  const digits = String(value || '').replace(/\D/g, '');
  return digits ? `•••• ${digits.slice(-4)}` : 'Not available';
};

export const getPlaidConnections = items => {
  if (!Array.isArray(items)) {
    throw new Error('Plaid connections could not be loaded.');
  }

  const keys = {};

  return items
    .filter(isActive)
    .sort((a, b) => timestamp(updatedDate(b)) - timestamp(updatedDate(a)))
    .map(item => {
      const accounts = Array.isArray(item.accounts)
        ? item.accounts.filter(isActive)
        : [];
      const identityKey =
        item.id ||
        JSON.stringify([
          item.created,
          item.names,
          accounts.map(account => account.id || account.account_number_redacted)
        ]);
      keys[identityKey] = (keys[identityKey] || 0) + 1;

      return {
        ...item,
        key: `${identityKey}-${keys[identityKey]}`,
        accounts,
        institutionName:
          accounts.find(account => account.bank_name)?.bank_name ||
          item.institution_name ||
          'Bank name unavailable',
        updated: updatedDate(item),
        addresses: Array.isArray(item.addresses) ? item.addresses : [],
        phone_numbers: Array.isArray(item.phone_numbers)
          ? item.phone_numbers
          : [],
        emails: Array.isArray(item.emails) ? item.emails : []
      };
    });
};
